import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=5ca59ead&scoped=true&"
import script from "./Block.vue?vue&type=script&lang=js&"
export * from "./Block.vue?vue&type=script&lang=js&"
import style0 from "./Block.vue?vue&type=style&index=0&id=5ca59ead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca59ead",
  null
  
)

export default component.exports